// extracted by mini-css-extract-plugin
module.exports = {"checkbox_label":"_2JiOqNz","tab_root":"_z_1KRs","tab_wrapper":"_3ab9TIe","initiating_credit_check":"hdByg_W"};